import { BufferGeometry, ExtrudeGeometry, Float32BufferAttribute } from "three";
import { toCreasedNormals } from "three/examples/jsm/utils/BufferGeometryUtils.js";
import { taperEnds } from "./taper";
const TRIANGLE_STRIDE = 9;
const midpoint = (t, a, b) => {
  var _a, _b, _c, _d, _e, _f;
  return [
    (((_a = t[a * 3]) != null ? _a : 0) + ((_b = t[b * 3]) != null ? _b : 0)) / 2,
    (((_c = t[a * 3 + 1]) != null ? _c : 0) + ((_d = t[b * 3 + 1]) != null ? _d : 0)) / 2,
    (((_e = t[a * 3 + 2]) != null ? _e : 0) + ((_f = t[b * 3 + 2]) != null ? _f : 0)) / 2
  ];
};
const corner = (t, i) => {
  var _a, _b, _c;
  return [
    (_a = t[i * 3]) != null ? _a : 0,
    (_b = t[i * 3 + 1]) != null ? _b : 0,
    (_c = t[i * 3 + 2]) != null ? _c : 0
  ];
};
function subdivide(geometry, passes) {
  const source = geometry.getAttribute("position");
  let positions = Array.from(source.array);
  for (let pass = 0; pass < passes; pass += 1) {
    const next = [];
    for (let i = 0; i < positions.length; i += TRIANGLE_STRIDE) {
      const triangle = positions.slice(i, i + TRIANGLE_STRIDE);
      const a = corner(triangle, 0);
      const b = corner(triangle, 1);
      const c = corner(triangle, 2);
      const ab = midpoint(triangle, 0, 1);
      const bc = midpoint(triangle, 1, 2);
      const ca = midpoint(triangle, 2, 0);
      next.push(...a, ...ab, ...ca);
      next.push(...ab, ...b, ...bc);
      next.push(...ca, ...bc, ...c);
      next.push(...ab, ...bc, ...ca);
    }
    positions = next;
  }
  const subdivided = new BufferGeometry();
  subdivided.setAttribute("position", new Float32BufferAttribute(positions, 3));
  return subdivided;
}
function buildShell(profile, settings, { depth, taper, passes, creaseAngle = Math.PI / 4 }) {
  const extruded = new ExtrudeGeometry(profile, settings);
  extruded.translate(0, 0, -depth / 2);
  if (!taper) return toCreasedNormals(extruded, creaseAngle);
  const subdivided = subdivide(extruded, passes != null ? passes : 2);
  taperEnds(subdivided, taper);
  return toCreasedNormals(subdivided, creaseAngle);
}
export {
  buildShell
};
